<template>
  <v-container fluid class="px-8">
    <v-card>
      <v-card-text class="pb-0">
        <v-container fluid>
          <div class="d-flex justify-end">
            <v-btn
              class="mt-4 mr-4"
              color="primary"
              fab
              small
            >
              <v-icon @click="roleFormEnabled = !roleFormEnabled">
                mdi-plus
              </v-icon>
            </v-btn>
          </div>

          <core-main-table
            ref="main"
            model-name="Role"
            rights-group="role"
            :headers="headers"
            :items="roles"
          >
            <template v-slot:item.rights="props">
              <v-chip
                v-for="(right, index) in props.item.rights"
                :key="index"
                class="ma-1 ml-0"
                small
              >
                {{ $t(`rights.${right}`) }}
              </v-chip>
            </template>
            <template v-slot:item.data-table-menu="props">
              <v-menu
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in menuItems"
                    :key="index"
                    link
                  >
                    <v-list-item-content>
                      <v-list-item-title @click="menuClick(item.value, props.item)">
                        {{ item.label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </core-main-table>

          <v-dialog
            v-model="roleFormEnabled"
            width="70%"
            @click:outside="roleData={}"
          >
            <form-role
              v-model="roleData"
              :loading="loading"
              @save="updateRole"
            />
          </v-dialog>
          <v-dialog
            v-model="deleteRoleBoxEnabled"
            persistent
            width="40%"
          >
            <v-card>
              <v-card-title class="headline">
                Confirm role deletion
              </v-card-title>
              <v-card-text> {{ roleDeleteConfirmationMessage }} </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="green darken-1" text @click="clearDeletionData()">
                  Cancel
                </v-btn>
                <v-btn color="green darken-1" text @click="deleteRole()">
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import headers from '../../headers';
import RolesMixin from '../../mixins/roles';
import UpdateEntityMixin from '../../mixins/update-entity';
import UsersMixin from '../../mixins/users';
import { LEVEL } from '../../utils/log';

export default {
  name: 'RoleSettings',

  mixins: [
    RolesMixin,
    UpdateEntityMixin,
    UsersMixin
  ],

  data() {
    return {
      roleFormEnabled: false,
      menuItems: [
        { label: 'Delete', value: 'delete' },
        { label: 'Edit', value: 'edit' },
      ],
      roleToDelete: {},
      deleteRoleBoxEnabled: false,
      roleDeleteConfirmationMessage: '',
      roleData: {},
      loading: false
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('common.name'),
          value: 'name',
        },
        {
          text: this.$t('form.role.fields.rights'),
          value: 'rights',
        },
        ...headers.updated.call(this),
        ...headers.inactive.call(this),
        {
          text: '',
          value: 'data-table-menu',
          items: this.menuItems,
        },
      ];
    },
  },

  mounted() {
    this.fetchUsers({ query: {} });
  },

  methods: {
    ...mapActions('app', [
      'pushSnack'
    ]),

    async updateRole(role) {
      this.loading = true;
      const { Role } = this.$FeathersVuex.api;
      const newRole = new Role(role);
      await this.updateEntity(undefined, newRole);
      this.roleFormEnabled = false;
      this.loading = false;
      this.roleData = {};
    },

    menuClick(menu, entity) {
      if (menu === 'delete') {
        // find users with the role
        const users = this.findUsers({ query: { roleIds: entity._id } }).data;
        // if there is at least one user with that role call the snack and display an error
        if (users.length > 0) {
          this.pushSnack({
            snack: { message: `${entity.name} role is already assigned to a user.\nUnassign role from user first: ${(() => {
              let usersList = '';
              users.forEach(user => {
                usersList += `<br>${user.email}`;
              });
              return usersList;
            })()}` },
            level: LEVEL.ERROR,
          });
        } else {
          this.roleToDelete = entity;
          this.roleDeleteConfirmationMessage = `are you sure you want to delete role ${this.roleToDelete.name}?`;
          this.deleteRoleBoxEnabled = true;
        }
      } else if (menu === 'edit') {
        // call update role
        this.roleData = entity.clone();
        this.roleFormEnabled = true;
      }
    },

    clearDeletionData() {
      this.deleteRoleBoxEnabled = false;
      this.roleToDelete = {};
      this.roleDeleteConfirmationMessage = '';
    },

    deleteRole() {
      this.removeRole(this.roleToDelete._id);
      this.pushSnack({
        snack: { message: 'Role deleted' },
        level: LEVEL.SUCCESS,
      });
      this.clearDeletionData();
    }
  },
};
</script>

<style scoped>

</style>
